import { UseControllerProps } from 'react-hook-form';

export const POSTAL_CODE_RULE: UseControllerProps['rules'] = {
  pattern: {
    value: /\b(?!(\d)\1{3})[13-9]{4}[1346-9][013-9]{5}\b/,
    message: 'کد پستی نامعتبر است',
  },
};
